module.exports = __webpack_public_path__ + "img/9788997980161.396d38d1.jpg";